// extracted by mini-css-extract-plugin
export var phone = "_3z-0";